import { useQuery } from '@tanstack/react-query';
import { backendServices } from "common";

export function useGetBuyerCompanyUserProfile(companyId?: number) {
    const { data, isLoading, isFetching, error } = useQuery(
        ['BuyerCompanyUserProfile', companyId],
        async () => {
            const api = new backendServices.Apis.CompanyApi();

            const res = await api.getBuyerCompanyUserProfile({ companyId });

            return res.data;
        },
        {
            staleTime: Infinity,
            cacheTime: Infinity,
        }
    );

    return {
        data,
        isLoading: isLoading || isFetching,
        error,
    };
}